import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginBottom: 16,
    marginTop: 24,
    minHeight: 104,
    padding: '16px 24px 24px 24px',
    backgroundColor: 'white',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
    borderRadius: 4,
  },
  title: {
    fontSize: 22,
    color: '#013957',
    borderBottom: 'thin solid #e7e7e7',
    paddingBottom: 8,
    marginBottom: 23,
    width: '100%',
    fontWeight: 'bold',
  },
  containerImages: {
    margin: '31px 0 10px 24px',
  },
  reference: {
    margin: '0 24px 0 0',
    '&:last-child': {
      margin: 0,
    }
  },
  img: {
    width: 32,
  },
}));


const CardSocialNetworks = props => {
  const { socialNetworks } = props;
  const classes = useStyles();


  return (
    <div className={classes.root}>
      <p className={classes.title}>Redes sociales</p>
      {socialNetworks && socialNetworks ? 
          <div className={classes.containerImages}>
            {socialNetworks.linkedIn ?
              <a 
                href={
                  socialNetworks.linkedIn && socialNetworks.linkedIn.includes('http') ?
                  `${socialNetworks.linkedIn}` :
                  socialNetworks.linkedIn && socialNetworks.linkedIn.includes('linkedin.com') ?
                  `https://www.${socialNetworks.linkedIn}` :
                  `${socialNetworks.linkedIn}`
                }
                target="_blank"
                rel="noopener noreferrer nofollow"
                className={classes.reference}
              >
                <img 
                  src='/img/socialNetworks/linke-in.svg'
                  alt="linkedIn"
                  className={classes.img}
                />
              </a> :
              null
            }
            {socialNetworks.twitter ?
              <a 
                href={`${socialNetworks.twitter}`}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className={classes.reference}
              >
                <img
                  src='/img/socialNetworks/twitter.svg'
                  alt="twitter"
                  className={classes.img}
                />
              </a> :
              null
            }
            {socialNetworks.facebook ?
              <a 
                href={`${socialNetworks.facebook}`}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className={classes.reference}
              >
                <img
                  src='/img/socialNetworks/facebook.svg'
                  alt="facebook"
                  className={classes.img}
                />
              </a> :
                null
              }
            {socialNetworks.instagram ?
              <a 
                href={`${socialNetworks.instagram}`}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className={classes.reference}
              >
                <img
                  src='/img/socialNetworks/instagram.png'
                  alt="instagram"
                  className={classes.img}
                />
              </a> :
              null
            }
            {socialNetworks.youtube ?
              <a 
                href={`${socialNetworks.youtube}`}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className={classes.reference}
              >
                <img
                  src='/img/socialNetworks/you-tube.svg'
                  alt="youtube"
                  className={classes.img}
                />
              </a>:
              null
            }
          </div> :
          null
      }
    </div>
  );
};

export default CardSocialNetworks;
